import { Box, keyframes } from '@mui/material'

// 生成中・処理中などの inline インジケータ. CircularProgress の回転より subtle で
// Notion 流の無装飾な点滅. 透明度 1↔0.4 で 1.5s infinite.
const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.4; }
`

interface Props {
  size?: number
  color?: string // sx 系の color tokens (例: 'text.primary' / 'text.disabled')
}

export const PulsingDot = ({ size = 10, color = 'text.primary' }: Props) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: '50%',
      bgcolor: color,
      animation: `${pulse} 1.5s infinite`,
      flexShrink: 0,
    }}
  />
)
